import React, { Component } from "react";
import { Drawer, Form, Input, DatePicker, TimePicker, Icon, notification, Select, Radio, Col, Row, InputNumber, Switch } from "antd";
import { GlobalContext } from "../../../app/providers/GlobalState";
import axios from "axios";
import moment from "moment";

import { calculateWorkload } from "../../../shared/utils/Diario/timeUtils";

const { Option } = Select;
const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class DrawerAdicionar extends Component {
    static contextType = GlobalContext;

    state = {
        dtAtendimento: "",
        hrAtendimento: "",
        //INERTVALO CALENDARIO
        dtInicio: null,
        dtTermino: null,
        //
        alunos: [],
        //LOADING
        iconLoading: false
    };

    componentDidMount() {
        this.intervaloCalendario();
        this.carregarAlunos();
    }

    intervaloCalendario = () => {
        axios({
            method: "get",
            url: "/api/aulas/intervalo-calendario-turma",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({
                    dtInicio: response.data.dt_inicio,
                    dtTermino: response.data.dt_termino
                });
            })
            .catch(() => {});
    };

    carregarAlunos = () => {
        axios({
            method: "get",
            url: "/api/atendimento/carregar-disciplinas-alunos",
            params: {
                id: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({
                    alunos: response.data
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao carregar os alunos.");
            });
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.criarAtendimento(values);
            }
        });
    };

    criarAtendimento = registo => {
        this.setState({ iconLoading: true });

        var item = new FormData();
        item.append("cursoId", registo.aluno);
        item.append("data", registo.data.format("YYYY/MM/DD"));
        item.append("hora", registo.horario.format("HH:mm"));
        item.append("duracao", registo.duracao);

        axios({
            method: "post",
            url: "/api/atendimento/adicionar-atendimento",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Atendimento criado com sucesso.");
                this.props.atualizarListagem();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao criar o atendimento.");
            })
            .finally(() => {
                this.setState({ iconLoading: false });
            });
    };

    afterVisibleChange = aberto => {
        if (aberto) {
            this.props.form.resetFields();

            const hasDataHoraInicio = !!this.props.dataHoraInicio;
            const dataInicio = hasDataHoraInicio ? moment(this.props.dataHoraInicio) : moment();

            const inicio = moment();
            const minutos = 15 - (inicio.minute() % 15);

            const hora = moment(inicio).add(minutos, "minutes");

            this.setState({
                dtAtendimento: hasDataHoraInicio ? dataInicio.clone() : moment(),
                hrAtendimento: hasDataHoraInicio ? dataInicio.clone() : hora
            });
        }
    };

    disabledDate = current => {
        return current < moment(this.state.dtInicio).startOf("day") || current > moment(this.state.dtTermino).endOf("day");
    };

    render() {
        const { getFieldDecorator } = this.props.form;

        const {
            dtAtendimento,
            hrAtendimento,
            alunos,
            //LOADING
            iconLoading
        } = this.state;

        const { visible } = this.props;

        return (
            <>
                <Drawer
                    title={
                        <div>
                            <div style={{ fontWeight: "bold", fontSize: 16 }}>Cadastro de Atendimento</div>
                            <div style={{ fontSize: 12, color: "#888" }}>
                                Preencha os dados para cadastrar um novo atendimento no calendário.
                            </div>
                        </div>
                    }
                    className="drawer-adicionar-evento"
                    width={720}
                    onClose={this.props.onClose}
                    visible={visible}
                    style={{
                        overflow: "auto",
                        height: "calc(100% - 108px)",
                        paddingBottom: "108px"
                    }}
                    maskClosable={false}
                    afterVisibleChange={this.afterVisibleChange}
                >
                    <div className="bloco-info">
                        <Form className="form-categorias" layout="horizontal" onSubmit={this.handleSubmit}>
                            <div className="bloco">
                                <Form.Item label="Data do Atendimento">
                                    {getFieldDecorator("data", {
                                        initialValue: dtAtendimento,
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ]
                                    })(
                                        <DatePicker
                                            className="input-25"
                                            placeholder="Selecionar"
                                            format="DD-MM-YYYY"
                                            name="dt_fimAula"
                                            onChange={this.handleChangeData}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label="Horário">
                                    {getFieldDecorator("horario", {
                                        initialValue: hrAtendimento,
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ]
                                    })(
                                        <TimePicker
                                            className="input-25"
                                            defaultOpenValue={moment("00:00", "HH:mm")}
                                            format="HH:mm"
                                            placeholder="Selecionar"
                                            suffixIcon={false}
                                            clearIcon={false}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label="Aluno">
                                    {getFieldDecorator("aluno", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ]
                                    })(
                                        <Select placeholder="Selecionar">
                                            {alunos.map(aluno => (
                                                <Option key={aluno.id} value={aluno.id}>
                                                    {aluno.nome}
                                                </Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label="Tempo de Atendimento">
                                    {getFieldDecorator("duracao", {
                                        initialValue: "00:30",
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ]
                                    })(
                                        <Select placeholder="Selecionar">
                                            <Option value="00:30">30 minutos</Option>
                                            <Option value="00:45">45 minutos</Option>
                                            <Option value="00:50">50 minutos</Option>
                                            <Option value="01:00">1 hora</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </div>
                            <div className="ant-drawer-footer">
                                <button
                                    className="botao-secundario"
                                    onClick={this.props.onClose}
                                    style={{ marginRight: 20, display: "inline-block" }}
                                    type="button"
                                >
                                    Voltar
                                </button>
                                <button className="botao-principal" disabled={iconLoading} type="primary">
                                    {iconLoading ? <Icon type="loading" /> : null}
                                    Salvar
                                </button>
                            </div>
                        </Form>
                    </div>
                </Drawer>
            </>
        );
    }
}

export default Form.create({ name: "form-drawer-adicionar-aula" })(DrawerAdicionar);
